<a href="" [routerLink]="'/use-cases/'+useCase.id">
    <div class="img-card" [bgImage]="useCase.imageSrc" [overlayColor]="useCase.imageOverlayColor">
        <div class="img-card-content">
            <h2 class="img-card-title">
                {{ useCase.title }}
            </h2>
            <div class="img-card-read-more">Read more</div>
        </div>
    </div>
</a>